(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["club444-finder"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('club444-finder')){customElements.define('club444-finder',class extends HTMLElement{
connectedCallback(){if(this.bound)return;this.bound=true;const form=this.querySelector('form');const result=this.querySelector('.c4-finder-result');const target=this.querySelector('[data-results]');form.hidden=false;this.querySelector('[data-fallback]').hidden=true;form.addEventListener('submit',event=>{event.preventDefault();const data=new FormData(form);const interest=data.get('interest');const budget=data.get('budget');const picks=[...this.querySelectorAll('template[data-pick]')];const pick=picks.find(p=>p.dataset.interest===interest&&(budget==='open'||(budget==='under'&&Number(p.dataset.price)<5000)||(budget==='middle'&&Number(p.dataset.price)>=5000&&Number(p.dataset.price)<=10000)));target.replaceChildren((pick||this.querySelector('[data-empty]')).content.cloneNode(true));form.hidden=true;result.hidden=false;result.focus();});this.querySelector('[data-reset]').addEventListener('click',()=>{result.hidden=true;form.hidden=false;form.querySelector('input:checked').focus();});}
});}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["club444-product-guide"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('club444-sticky')){customElements.define('club444-sticky',class extends HTMLElement{connectedCallback(){if(this.observer)return;const form=document.querySelector('.product-single__meta form[action*="/cart/add"]');if(!form)return;const button=form.querySelector('[type="submit"]');if(!button)return;const link=this.querySelector('a');link.addEventListener('click',event=>{event.preventDefault();form.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'center'});button.focus({preventScroll:true});});this.observer=new IntersectionObserver(entries=>{const entry=entries[0];this.classList.toggle('is-visible',!entry.isIntersecting&&entry.boundingClientRect.bottom<0);},{threshold:0});this.observer.observe(button);}disconnectedCallback(){this.observer?.disconnect();this.observer=null;}});}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["club444-routines"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('club444-pair')){customElements.define('club444-pair',class extends HTMLElement{
connectedCallback(){if(this.bound)return;this.bound=true;this.querySelector('form').addEventListener('submit',async event=>{event.preventDefault();const form=event.currentTarget;const button=form.querySelector('button');if(button.disabled)return;const status=form.querySelector('[role="status"]');const label=button.textContent;button.disabled=true;button.textContent=this.dataset.adding;status.textContent='';const items=[...form.querySelectorAll('select')].map(select=>({id:Number(select.value),quantity:1}));try{const response=await fetch(this.dataset.addUrl,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});const result=await response.json();if(!response.ok)throw new Error(result.description||this.dataset.error);window.location.assign(this.dataset.cartUrl);}catch(error){status.textContent=error.message||this.dataset.error;button.disabled=false;button.textContent=label;}});}
});}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  class KitShoppableHero extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      if (window.theme && window.theme.sections) {
        this.initQuickShop();
      } else {
        document.addEventListener('page:loaded', () => this.initQuickShop(), { once: true, signal });
      }

      if (this.querySelector('kit-popover')) {
        window.addEventListener('scroll', () => {
          this.querySelectorAll('kit-popover:popover-open').forEach(p => p.hidePopover());
        }, { passive: true, signal });
      }

      if (!Shopify.designMode) return;

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.contains(this)) {
          this.initQuickShop();
        }
      }, { signal });

      this.addEventListener('shopify:block:select', (event) => {
        this.initQuickShop();
        const btn = event.target.querySelector('button');
        if (btn) btn.click();
      }, { signal });

      this.addEventListener('shopify:block:deselect', (event) => {
        const popover = event.target.querySelector('kit-popover');
        if (popover) popover.hidePopover?.();
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    initQuickShop() {
      if (!theme.settings.quickView) return;

      var sectionEl = this.closest('[id^="shopify-section-"]');
      var links = this.querySelectorAll('.shoppable-hero__popover-link[data-product-handle]');
      if (!links.length) return;

      links.forEach(link => {
        if (link.dataset.shoppableHeroBound === 'true') return;
        link.dataset.shoppableHeroBound = 'true';

        var handle = link.dataset.productHandle;
        var productId = link.dataset.productId;

        if (!document.getElementById('QuickShopModal-' + productId)) return;

        // Capture-phase interceptor registered before modal binds its handler.
        // On mobile, blocks the modal handler so the link navigates normally.
        link.addEventListener('click', (event) => {
          if (theme.config.bpSmall) {
            event.stopImmediatePropagation();
            return;
          }
          const popover = event.target.closest('kit-popover');
          if (popover) popover.hidePopover?.();
        }, true);

        var hotspot = link.closest('.kit-shoppable-hero__hotspot');
        if (!hotspot) return;

        var preloadOnce = function() {
          if (link.dataset.shoppableHeroPreloaded === 'true') return;
          if (theme.config.bpSmall) return;

          // If a holder already exists from another section (e.g. product grid),
          // remove our duplicate modal shell to avoid duplicate IDs
          var holder = document.getElementById('QuickShopHolder-' + handle);
          if (holder && sectionEl) {
            var holderSection = holder.closest('[id^="shopify-section-"]');
            if (holderSection && holderSection !== sectionEl) {
              var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
              if (duplicate) duplicate.remove();
            }
          }

          link.dataset.shoppableHeroPreloaded = 'true';
          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);

          hotspot.removeEventListener('mouseover', preloadOnce);
          hotspot.removeEventListener('focusin', preloadOnce);
        };

        hotspot.addEventListener('mouseover', preloadOnce);
        hotspot.addEventListener('focusin', preloadOnce);
      });
    }
  }

  customElements.define('kit-shoppable-hero', KitShoppableHero);

  } catch(e) { console.error(e); }
})();
})();
